import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        // ➜ Նոր էջ, առանց hash → վերև
        if (!location.hash) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [location.pathname]);

    return null;
}
